import { clientReportRoutes, clientReportNav } from './client-reports/routes'
import type { FeatureRoute, NavItem } from './types'
import { dashboardRoutes, dashboardNav } from './dashboard/routes'
import { dealsRoutes, dealsNav } from './deals/routes'
import { rfpRoutes, rfpNav } from './rfp/routes'
import { contactsRoutes, contactsNav } from './contacts/routes'
import { revenueRoutes, revenueNav } from './revenue/routes'
import { onboardingRoutes, onboardingNav } from './onboarding/routes'
import { aiRoutes, aiNav } from './ai/routes'
import { workspaceRoutes, workspaceNav } from './workspace/routes'
import { adminRoutes, adminNav } from './admin/routes'

/**
 * The feature-slice registry. App.tsx maps `featureRoutes` and the Sidebar maps
 * `featureNav` — neither lists individual entries, so feature teams never edit a
 * shared file to add a page or a nav link.
 *
 * To add a NEW feature slice: create `features/<name>/routes.tsx` (exporting its
 * routes + nav) and append one spread line to each array below. To add a route
 * or nav link to an EXISTING feature: edit only that feature's `routes.tsx`.
 * This file is the only shared touchpoint (append-only).
 */
export const featureRoutes: FeatureRoute[] = [
  ...dashboardRoutes,
  ...clientReportRoutes,
  ...dealsRoutes,
  ...rfpRoutes,
  ...contactsRoutes,
  ...revenueRoutes,
  ...onboardingRoutes,
  ...aiRoutes,
  ...workspaceRoutes,
  ...adminRoutes,
]

export const featureNav: NavItem[] = [
  ...dashboardNav,
  ...clientReportNav,
  ...dealsNav,
  ...rfpNav,
  ...contactsNav,
  ...revenueNav,
  ...onboardingNav,
  ...aiNav,
  ...workspaceNav,
  ...adminNav,
]
